import script from "./FormulasQuestInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasQuestInfo.vue?vue&type=script&setup=true&lang=js"

import "./FormulasQuestInfo.vue?vue&type=style&index=0&id=6acf9190&lang=scss"

const __exports__ = script;

export default __exports__